import React, { useState } from "react";
import { Box, styled, Typography } from "@mui/material";
import { Help, OnlinePrediction, OfflinePin, Apartment, Diamond  } from "@mui/icons-material";
import RM_first from "./comps/RM_first";
import RM_second from "./comps/RM_second";
import RM_third from "./comps/RM_third";
import RM_fourth from "./comps/RM_fourth";
import RM_fifth from "./comps/RM_fifth";


const ProcessName = styled(Typography, {shouldForwardProp: (prop) => prop !== 'activeIndex'})(({ activeIndex, theme }) => ({
  fontSize: '1.5rem',
  color: activeIndex ? '#242424' : 'white',
  height: '50%',
  textAlign: 'center',
  
  [theme.breakpoints.down('xl')]: {
    fontSize: '1.2rem',
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: '1rem',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '0.8rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.6rem',
  },
}));

const getStyledIcon = (Icon) =>
  styled(Icon)(({ theme }) => ({
    padding: theme.spacing(1),
    border: '5px solid #fff',
    borderRadius: '50%',
    backgroundColor: '#ffdd24',
    fontSize: '2.5rem',
    
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0.5),
      fontSize: '1.8rem',
      border: '3px solid #fff',

    }
}));


const RMCard = ({ index, Icon, Title, activeIndex, setActiveIndex }) => {

  const StyledIcon = getStyledIcon(Icon);

    const handleOnclick = () => {
      setActiveIndex(index);
    }

    return (
      <Box
      onClick={handleOnclick}
      sx={{ width: "18vw", height: "20vh",
        background: activeIndex === index ? 'linear-gradient(to top, rgb(196, 254, 235) 75%, transparent 25%)' : 'linear-gradient(to top, rgb(36, 36, 36) 75%, transparent 25%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '5px',
        cursor: 'pointer',
        marginTop: activeIndex === index ? 3 : 0,
        borderBottomLeftRadius: activeIndex === index ? 0 : '5px',
        borderBottomRightRadius: activeIndex === index ? 0 : '5px',
        borderTop: activeIndex === index ? '2px solid #242424' : 'none',
        borderLeft: activeIndex === index ? '2px solid #242424' : 'none',
        borderRight: activeIndex === index ? '2px solid #242424' : 'none',
        
        '&:hover': {
          background: 'linear-gradient(to top, #ffdd24 75%, transparent 25%)',
          '& .iconStyle':{
            bgcolor: '#242424',
            color: '#ffdd24',
            transition: 'all 0.3s ease',
          },
          
          '& .titleStyle':{
            color: '#242424',
            transition: 'all 0.3s ease',
          },
        }

       }}>
        <Box sx={{ width: '100%', height: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'  }} >
            <StyledIcon className="iconStyle" />
        </Box>
        <ProcessName className="titleStyle" activeIndex={activeIndex === index} >{Title}</ProcessName>
      </Box>
    );
}

function ResearchMethodology() {

    const [activeIndex, setActiveIndex] = useState(0);

    const processes = [
        {
            icon: Help,
            title: "How Do We Conduct Market Research",
            component: RM_first
        },
        {
            icon: OnlinePrediction,
            title: "Market Sizing And Forecasting",
            component: RM_second
        },
        {
            icon: OfflinePin,
            title: "Triangulation And Validation",
            component: RM_third
        },
        {
            icon: Apartment,
            title: "Company Profile Research",
            component: RM_fourth
        },
        {
            icon: Diamond,
            title: "Our Values In Research",
            component: RM_fifth
        },
    ];
    
    const ActiveComponent = processes[activeIndex].component;
    
  return (
    <Box
      id="ResearchMethodology-section"
      sx={{
        position: 'relative',
        width: "100%",
        // height: "70vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 0.3,
        py: 5,
        bgcolor: "#fff",
        // background: "linear-gradient(to top, rgb(196, 254, 235) 64.5%, #fff 35.5%)",
      }}
    >
      <Box
        sx={{ position: 'relative', zIndex: 2, width: "95%", display: "flex", justifyContent: "space-between", }}
      >
        {processes.map((process, index) => (
          <RMCard
            index={index}
            key={process.title}
            Icon={process.icon}
            Title={process.title}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
          />
        ))}
      </Box>

      <Box sx={{ position: 'relative', zIndex: 1, bgcolor: '#c4feeb', width: "100%", mt: -0.5, borderTop: '2px solid #242424', borderBottom: '2px solid #242424', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
        <ActiveComponent/>
      </Box>
    </Box>
  );
}

export default ResearchMethodology;
